module.exports = __webpack_public_path__ + "static/media/fluxoCurso.7ed01dc3.png";